var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.125 2.25C0.125 1.29297 0.890625 0.5 1.875 0.5H8.875C9.83203 0.5 10.625 1.29297 10.625 2.25V9.25C10.625 10.2344 9.83203 11 8.875 11H1.875C0.890625 11 0.125 10.2344 0.125 9.25V2.25ZM15.4102 1.48438C15.6836 1.64844 15.875 1.94922 15.875 2.25V9.25C15.875 9.57812 15.6836 9.87891 15.4102 10.043C15.1094 10.1797 14.7812 10.1797 14.5078 9.98828L11.8828 8.23828L11.5 7.99219V7.5V4V3.53516L11.8828 3.28906L14.5078 1.53906C14.7812 1.34766 15.1094 1.34766 15.4102 1.48438Z",
    fill: "#33FF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOn);
export default __webpack_public_path__ + "static/media/camera-on.0942633ed1b7d6ebda4c3a9820b8c1e2.svg";
export { ForwardRef as ReactComponent };